import { render } from "./GalleryItem.vue?vue&type=template&id=7854497b&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"

import "./GalleryItem.vue?vue&type=style&index=0&id=7854497b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7854497b"]])

export default __exports__